import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=6c257c0b"
import script from "./NotificationItem.vue?vue&type=script&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&lang=ts"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=6c257c0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports